import type { CandidateRecord } from '../types/market.js';
import { percentChange } from './number.js';

/**
 * Applies a lightweight live radar price to a deeply validated thesis without
 * borrowing the earlier radar observation's discovery clock. This is critical
 * when deep chart history promotes a previously neutral Eagle Watch row.
 */
export function mergeCandidateWithLiveObservation(
  live: CandidateRecord,
  deep?: CandidateRecord,
): CandidateRecord {
  if (!deep) return live;

  const changeSinceFound = percentChange(live.currentPrice, deep.foundPrice);
  const favorableMove = deep.direction === 'short' ? -changeSinceFound : changeSinceFound;

  return {
    ...deep,
    currentPrice: live.currentPrice,
    currentChange24h: live.currentChange24h,
    changeSinceFound,
    bestMove: Math.max(deep.bestMove, favorableMove),
    worstMove: Math.min(deep.worstMove, favorableMove),
    candleMaturity: live.candleMaturity,
    secondsToClose: live.secondsToClose,
    freshIssuanceAllowed: live.freshIssuanceAllowed,
    sampleCoverageMs: live.sampleCoverageMs,
    dataQuality: Math.max(live.dataQuality, deep.dataQuality),
    lastUpdatedAt: live.lastUpdatedAt,
  };
}
